import { render, staticRenderFns } from "./cateMerchant.vue?vue&type=template&id=5826ce6f&scoped=true&"
import script from "./cateMerchant.vue?vue&type=script&lang=js&"
export * from "./cateMerchant.vue?vue&type=script&lang=js&"
import style0 from "./cateMerchant.vue?vue&type=style&index=0&id=5826ce6f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826ce6f",
  null
  
)

export default component.exports